import clsx from 'clsx';
import React, { Fragment } from 'react';

import ViewLink from '../ViewLink';

interface TabsProps {
  customPath?: ({ view }: { view: string }) => string;
  styles?: string;
  tabs: {
    to: string;
    text: string;
  }[];
  view: string;
}

const Tabs = ({ customPath, styles = 'max-w-[322px]', tabs, view }: TabsProps): JSX.Element => {
  const numOfTabs = tabs.length - 1;

  return (
    <div
      className={clsx(
        'mx-32 flex min-w-[260px] justify-between border-0 border-b border-solid border-black sm:mx-0',
        styles
      )}
      role="tablist"
      data-testid="tabs"
    >
      {tabs.length > 0 &&
        tabs.map((tab, index) => (
          <Fragment key={`${tab.text.replaceAll(' ', '-')}-${index}`}>
            <ViewLink
              customPath={customPath}
              role="tab"
              text={tab.text}
              to={tab.to}
              isActive={view === tab.to}
            />
            {numOfTabs > index && <div className="-mb-3 w-[1px] rotate-[-30deg] bg-black" />}
          </Fragment>
        ))}
    </div>
  );
};

export default Tabs;
